import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileSaver from 'file-saver';
import React from 'react';
import { useDispatch } from 'react-redux';

import { fetchSiteListingForSiteGroup } from '@sophocles/entities/SiteGroup';
import ReportLinkItem from '@sophocles/views/reports/components/ReportLinkItem';

function SiteListingContainer({ isBillboard, siteGroupId, siteGroup }) {
  const dispatch = useDispatch();

  const fetchData = () => {
    const filename = `${siteGroup?.name ?? ''}_${siteGroup?.description ?? ''}.xlsx`;

    dispatch(fetchSiteListingForSiteGroup(siteGroupId)).then(blob => FileSaver.saveAs(new Blob([blob]), filename));
  };

  return (
    <ReportLinkItem
      onClick={fetchData}
      icon={<FileDownloadOutlinedIcon />}
      primary={`Download ${isBillboard ? 'Structure' : 'Site'} Listing`}
      secondary="Export this group's list as an Excel spreadsheet"
    />
  );
}

export default SiteListingContainer;
